import { EMPTY_VALUE, DEFAULT_VALUE } from '@wix/form-fields';
export const fillEmptyValues = function (form, values, recursive) {
  if (recursive === void 0) {
    recursive = true;
  }
  if (!(form != null && form.fields)) {
    return {};
  }
  return form.fields.reduce((result, field) => {
    var _field$view, _field$view2, _field$view3;
    const fieldTarget = field.target;
    if (!fieldTarget) {
      return result;
    }
    const fieldValue = values == null ? void 0 : values[fieldTarget];
    const defaultValue = (_field$view = field.view) == null ? void 0 : _field$view.defaultValue;
    const fieldType = (_field$view2 = field.view) == null ? void 0 : _field$view2.fieldType;
    const nestedForm = (_field$view3 = field.view) == null ? void 0 : _field$view3.form;
    if (recursive && nestedForm) {
      result[fieldTarget] = fillEmptyValues(nestedForm, fieldValue, false);
    } else if (fieldValue !== undefined) {
      result[fieldTarget] = fieldValue;
    } else if (defaultValue !== undefined) {
      var _DEFAULT_VALUE;
      result[fieldTarget] = (_DEFAULT_VALUE = DEFAULT_VALUE[fieldType]) == null ? void 0 : _DEFAULT_VALUE.call(DEFAULT_VALUE, field);
    } else if (fieldType) {
      result[fieldTarget] = EMPTY_VALUE;
    }
    return result;
  }, {});
};
//# sourceMappingURL=form-values.js.map